import { render, staticRenderFns } from "./PredictedCategorySection.vue?vue&type=template&id=32dab7b0&"
import script from "./PredictedCategorySection.vue?vue&type=script&lang=js&"
export * from "./PredictedCategorySection.vue?vue&type=script&lang=js&"
import style0 from "./PredictedCategorySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports